import {
  CUSTOMER_INVOICE_GET,
  NAME_TITLE_GET,
  OMISE_SEND,
  OMISE_SEND_CUSTOMER,
  WIDTHHOLDINGTAX_GET,
  BILL_SLIP_SEND,
  BILL_SLIP_INVOICE_SEND,
  BANK_PAYMENT_GET,
} from "../actions";

import {
  getCustomerInvoiceSuccess,
  getNameTitleSuccess,
  getWidthHoldingTaxSuccess,
  getBankPaymentSuccess,
  sendOmiseSuccess,
} from "../customerInvoice/actions";

import apiSetting from "../../services/setting";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

function* getBankPayment({ payload }) {
  try {
    const dataRes = yield apiSetting.BankPayment(payload);
    // ★ แก้: dispatch success เสมอ ไม่ว่า data จะว่างหรือไม่
    yield put(getBankPaymentSuccess(dataRes || []));
  } catch (error) {
    console.log("getBankPayment error:", error);
    // ★ แก้: dispatch success ด้วย [] เมื่อ error เพื่อให้ loading = false
    yield put(getBankPaymentSuccess([]));
  }
}

// function* getCustomerInvoice({ payload }) {
//   try {
//     const dataRes = yield apiSetting.CustomerInvoice(payload);
//     // ★ แก้: dispatch success เสมอ
//     yield put(getCustomerInvoiceSuccess(dataRes || []));
//   } catch (error) {
//     console.log("getCustomerInvoice error:", error);
//     // ★ แก้: dispatch success ด้วย [] เมื่อ error
//     yield put(getCustomerInvoiceSuccess([]));
//   }
// }

function* getCustomerInvoice({ payload }) {
  try {
    console.log("=== getCustomerInvoice payload ===", payload);
    const dataRes = yield apiSetting.CustomerInvoice(payload);
    console.log("=== getCustomerInvoice dataRes ===", dataRes);
    console.log("=== dataRes type ===", typeof dataRes, Array.isArray(dataRes));
    yield put(getCustomerInvoiceSuccess(dataRes || []));
  } catch (error) {
    console.log("getCustomerInvoice error:", error);
    yield put(getCustomerInvoiceSuccess([]));
  }
}

function* getWidthHoldingTax({ payload }) {
  try {
    const dataRes = yield apiSetting.WithHoldingTax(payload);
    // ★ แก้: dispatch success เสมอ
    yield put(getWidthHoldingTaxSuccess(dataRes || []));
  } catch (error) {
    console.log("getWidthHoldingTax error:", error);
    // ★ แก้: dispatch success ด้วย [] เมื่อ error
    yield put(getWidthHoldingTaxSuccess([]));
  }
}

function* getNameTitle({ payload }) {
  try {
    const dataRes = yield apiSetting.NameTitle(payload);
    // ★ แก้: dispatch success เสมอ
    yield put(getNameTitleSuccess(dataRes || []));
  } catch (error) {
    console.log("getNameTitle error:", error);
    // ★ แก้: dispatch success ด้วย [] เมื่อ error
    yield put(getNameTitleSuccess([]));
  }
}

function* sendOmise({ payload }) {
  try {
    const dataRes = yield apiSetting.SendOmise(payload);
    if (dataRes.length != 0) {
      yield put(sendOmiseSuccess(dataRes));
    } else {
      // ★ แก้: dispatch success ด้วย [] เมื่อ data ว่าง
      yield put(sendOmiseSuccess([]));
    }
  } catch (error) {
    console.log("sendOmise error:", error);
    yield put(sendOmiseSuccess([]));
  }
}

function* sendOmiseCustomer({ payload }) {
  try {
    const dataRes = yield apiSetting.SendOmiseCustomer(payload);
  } catch (error) {
    console.log("sendOmiseCustomer error:", error);
  }
}

function* sendBillSlip({ payload }) {
  try {
    const dataRes = yield apiSetting.SendBillSlip(payload);
  } catch (error) {
    console.log("sendBillSlip error:", error);
  }
}

function* SendBillSlipInvoice({ payload }) {
  try {
    const dataRes = yield apiSetting.SendBillSlipInvoice(payload);
  } catch (error) {
    console.log("SendBillSlipInvoice error:", error);
  }
}

export function* watchgetCustomerInvoice() {
  yield takeEvery(CUSTOMER_INVOICE_GET, getCustomerInvoice);
}
export function* watchgetNameTitle() {
  yield takeEvery(NAME_TITLE_GET, getNameTitle);
}
export function* watchsendOmise() {
  yield takeEvery(OMISE_SEND, sendOmise);
}
export function* watchsendOmiseCustomer() {
  yield takeEvery(OMISE_SEND_CUSTOMER, sendOmiseCustomer);
}
export function* watchgetWidthHoldingTax() {
  yield takeEvery(WIDTHHOLDINGTAX_GET, getWidthHoldingTax);
}
export function* watchsendBillSlip() {
  yield takeEvery(BILL_SLIP_SEND, sendBillSlip);
}
export function* watchgetBankPayment() {
  yield takeEvery(BANK_PAYMENT_GET, getBankPayment);
}
export function* watchsendBillSlipInvoice() {
  yield takeEvery(BILL_SLIP_INVOICE_SEND, SendBillSlipInvoice);
}

export default function* rootSaga() {
  yield all([
    // =========AuthUser=======
    fork(watchgetCustomerInvoice),
    fork(watchgetNameTitle),
    fork(watchsendOmise),
    fork(watchsendOmiseCustomer),
    fork(watchgetWidthHoldingTax),
    fork(watchsendBillSlip),
    fork(watchgetBankPayment),
    fork(watchsendBillSlipInvoice),
  ]);
}